import { submitSteps } from "@/mocks/home";
import Reveal from "@/components/base/Reveal";
import SectionHeading from "./SectionHeading";
import SubmitForm from "./SubmitForm";

type SubmitFlowProps = {
  onSubmit: (summary: string) => void;
};

export default function SubmitFlow({ onSubmit }: SubmitFlowProps) {
  return (
    <section id="submit" className="w-full border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-[1440px] px-4 md:px-6">
        <SectionHeading
          icon="ri-quill-pen-line"
          eyebrow="匿名投稿 · SUBMIT"
          title="四步走完，你的线报就能挂上话题墙"
          desc="不用注册账号，不用留联系方式。写下你看到的、听到的，标注来源等级，剩下的交给值班编辑去核对。"
        />

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1fr] lg:gap-12">
          <Reveal>
            <ol className="flex flex-col gap-3">
              {submitSteps.map((item) => (
                <li
                  key={item.step}
                  className="flex items-start gap-4 rounded-lg border border-background-300 bg-background-100 p-4 transition-colors duration-300 hover:border-primary-300 md:p-5"
                >
                  <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-primary-500 font-heading text-base font-bold text-background-50">
                    {item.step}
                  </span>
                  <div>
                    <h4 className="flex items-center gap-2 font-heading text-base font-bold text-foreground-950">
                      <span className="flex h-4 w-4 items-center justify-center text-primary-600">
                        <i className={`${item.icon} text-base`} />
                      </span>
                      {item.title}
                    </h4>
                    <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{item.desc}</p>
                  </div>
                </li>
              ))}
            </ol>

            <div className="mt-5 rounded-lg border border-accent-200 bg-accent-50 p-4">
              <p className="flex items-start gap-2 text-xs leading-relaxed text-accent-900">
                <span className="flex h-4 w-4 shrink-0 items-center justify-center text-accent-700">
                  <i className="ri-error-warning-line" />
                </span>
                请勿提交涉及真实个人隐私、联系方式或未经证实的指控性内容。本站会保留原始表述，但不对投稿真实性作背书。
              </p>
            </div>
          </Reveal>

          <Reveal delay={80}>
            <div className="rounded-lg border border-background-300 bg-background-100 p-5 md:p-7">
              <div className="mb-5 flex items-center gap-3 border-b border-background-200 pb-5">
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-100 text-primary-700">
                  <i className="ri-edit-box-line text-xl" />
                </span>
                <div>
                  <h4 className="font-heading text-lg font-bold text-foreground-950">投稿表单</h4>
                  <p className="text-xs text-foreground-500">填写越具体，初筛通过率越高</p>
                </div>
              </div>
              <SubmitForm onSubmit={onSubmit} />
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}